import React from 'react';

const templeteIcon = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 26 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.66659 1.66699H22.3333C23.6166 1.66699 24.6666 2.71699 24.6666 4.00033V18.0003C24.6666 19.2837 23.6166 20.3337 22.3333 20.3337H3.66659C2.38325 20.3337 1.33325 19.2837 1.33325 18.0003V4.00033C1.33325 2.71699 2.38325 1.66699 3.66659 1.66699Z"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.6666 4L12.9999 12.1667L1.33325 4"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default templeteIcon;
